import { DynamicRouterPath } from '../../dynamic-router-path';
import { RouterPath } from '../../router-path';
export var testMakerAppPath = {
  space: RouterPath.create('/bricks?menu=space&level=1'),
  callback: DynamicRouterPath.createWithDynamic(function (id) {
    return RouterPath.create("/callback/".concat(id));
  }, '/callback/[accessId]'),
  form: {
    edit: DynamicRouterPath.createWithDynamic(function (id) {
      return RouterPath.create("/bricks/space/".concat(id));
    }, '/bricks/space/[id]'),
    preview: DynamicRouterPath.createWithDynamic(function (id) {
      return RouterPath.create("/bricks/space/".concat(id));
    }, '/bricks/space/[id]')
  },
  assignment: {
    list: DynamicRouterPath.createWithDynamic(function (assignmentType) {
      return RouterPath.create("/bricks?menu=".concat(assignmentType));
    }, '/bricks?menu=[assignmentType]'),
    detail: DynamicRouterPath.createWithDynamic(function (id, assignmentType) {
      return RouterPath.create("/bricks/".concat(assignmentType, "/").concat(id));
    }, '/bricks/[assignmentType]/[id]')
  },
  submission: {
    preview: DynamicRouterPath.createWithDynamic(function (id) {
      return RouterPath.create("/submission/preview/".concat(id));
    }, 'submission/preview/[id]')
  },
  explore: {
    groupCategory: RouterPath.create('/bricks?menu=explore').setPublicPath(),
    detail: DynamicRouterPath.createWithDynamic(function (id) {
      return RouterPath.create("/bricks/explore/category/".concat(id));
    }, '/bricks/explore/category/[id]')
  }
};